import { Color, getThemeForKey, ValueDisplayValue } from "@mcleod/core";
import { ComponentPropDefinitionUtil, ComponentPropDefinitions } from "../../base/ComponentProps";
import { PropType } from "../../base/PropType";
import { RadioButton } from "./RadioButton";
import { RadioGroupPropDefinitions, RadioGroupProps } from "./RadioGroupProps";

export interface RadioButtonGroupProps extends RadioGroupProps {
    buttonFillColor: Color;
    buttonSize: number;
}

export class RadioButtonGroupPropDefinitions {
    private static radioButtonGroupPropsDefs: ComponentPropDefinitions;

    public static getDefinitions(): ComponentPropDefinitions {
        if (this.radioButtonGroupPropsDefs == null) {
            this.radioButtonGroupPropsDefs = {
                ...RadioGroupPropDefinitions.cloneDefs(),
                ...this.buildSimpleProps(),
            };
            this.updateItemsProperty();
            this.adjustEventSignatures();
            ComponentPropDefinitionUtil.populateComponentPropNames(this.radioButtonGroupPropsDefs);
        }
        return this.radioButtonGroupPropsDefs;
    }

    private static buildSimpleProps(): ComponentPropDefinitions {
        return {
            buttonFillColor: {
                type: PropType.color,
                defaultValue: getThemeForKey("radioButton.image").color, 
                visibleInMcLeodTailor: true,
                description: "This sets the color of the selection indicator portion of the radio button circle.  The default is the current theme's primary color."
            },
            buttonSize: {
                type: PropType.number,
                defaultValue: getThemeForKey("radioButton").size, 
                visibleInMcLeodTailor: true,
                description: "This sets this pixel height and width of the circular radio image."
            }
        };
    }

    private static updateItemsProperty() {
        this.radioButtonGroupPropsDefs.items.type = PropType.radioButtonGroupItem;
        this.radioButtonGroupPropsDefs.items.description =
            "This specifies the list of items that will be represented as radio buttons.";
    }

    private static adjustEventSignatures() {
        this.radioButtonGroupPropsDefs.afterSelection.eventSignature =
            "AfterSelection(event: RadioButtonSelectionEvent)";
        this.radioButtonGroupPropsDefs.beforeSelection.eventSignature =
            "BeforeSelection(event: RadioButtonSelectionEvent)";
    }
}
